import { changeConceptSelected } from "../slices/codeSystemTermDetail/codeSystemTermDetailSlice";
import { resourceUpdated } from "../slices/resourceCollection/resourceCollectionSlice";
import jsonEquals from "../functions/jsonEquals";

const updateElement = (resourceState, elementName, datatypeForChangeReport, parentResourceDetail,
    dispatch) => {
    const previousInitialValue = parentResourceDetail.resourceJson[elementName]; // ?? null
    const previousFinalValue = parentResourceDetail.revisedResourceJson[elementName]; // ?? null
    if (resourceState[elementName] !== undefined
        && (datatypeForChangeReport === 'boolean' || previousInitialValue || previousFinalValue || resourceState[elementName])
        && (previousInitialValue || !Array.isArray(resourceState[elementName]) || resourceState[elementName].length > 1 || resourceState[elementName][0])
        && !jsonEquals(previousFinalValue, resourceState[elementName])
    ) {
        console.log("resourceUpdate for Resource." + elementName);
        let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
        newResourceDetail.revisedResourceJson[elementName] = typeof (resourceState[elementName]) === "object" ? JSON.parse(JSON.stringify(resourceState[elementName])) : resourceState[elementName];
        if (elementName === "comparisonGroup") {
            const previousFinalContainedValue = parentResourceDetail.revisedResourceJson["contained"];
            if (resourceState["contained"] && !jsonEquals(previousFinalContainedValue, resourceState["contained"])) {
                console.log("resourceUpdate for Resource.contained");
                newResourceDetail.revisedResourceJson["contained"] = JSON.parse(JSON.stringify(resourceState["contained"]))
            }
        }
        dispatch(resourceUpdated(newResourceDetail));
    }
}

const updateNarrativeElement = (resourceState, elementName, parentResourceDetail,
    dispatch) => {
    const previousFinalValue = parentResourceDetail.revisedResourceJson[elementName];
    if (resourceState[elementName] !== undefined && !jsonEquals(previousFinalValue, resourceState[elementName])
        && !(previousFinalValue === undefined &&
            resourceState[elementName].status === "empty")) {
        console.log("resourceUpdate for Resource." + elementName);
        let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
        newResourceDetail.revisedResourceJson[elementName] = resourceState[elementName];
        dispatch(resourceUpdated(newResourceDetail));
    }
}

const updateCitedArtifactElement = (citedArtifactState, elementName, datatypeForChangeReport, parentResourceDetail,
    dispatch) => {
    const previousInitialValue = parentResourceDetail.resourceJson.citedArtifact?.[elementName];
    const previousFinalValue = parentResourceDetail.revisedResourceJson.citedArtifact?.[elementName];
    if (citedArtifactState?.[elementName] !== undefined &&
        !jsonEquals(previousFinalValue, citedArtifactState[elementName]) &&
        !(!previousInitialValue &&
            Array.isArray(citedArtifactState[elementName]) &&
            (citedArtifactState[elementName].length === 0 ||
                (citedArtifactState[elementName].length === 1 && !citedArtifactState[elementName][0])
            )
        ) && !(datatypeForChangeReport !== 'boolean' && !previousInitialValue && !previousFinalValue && !citedArtifactState[elementName])
    ) {
        let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
        if (!newResourceDetail.revisedResourceJson.citedArtifact) {
            newResourceDetail.revisedResourceJson.citedArtifact = {};
        }
        newResourceDetail.revisedResourceJson.citedArtifact[elementName] = citedArtifactState?.[elementName];
        console.log("resourceUpdate for Citation.citedArtifact." + elementName);
        dispatch(resourceUpdated(newResourceDetail));
    }
}

const updateCitedArtifactPublicationFormElement = (publicationFormState, index, elementName, datatypeForChangeReport, parentResourceDetail,
    dispatch) => {
    const previousInitialValue = parentResourceDetail.resourceJson.citedArtifact?.publicationForm?.[index]?.[elementName];
    const previousFinalValue = parentResourceDetail.revisedResourceJson.citedArtifact?.publicationForm?.[index]?.[elementName];

    if (publicationFormState[elementName] !== undefined &&
        !jsonEquals(previousFinalValue, publicationFormState[elementName]) &&
        !(!previousInitialValue &&
            Array.isArray(publicationFormState[elementName]) &&
            (publicationFormState[elementName].length === 0 ||
                (publicationFormState[elementName].length === 1 && !publicationFormState[elementName][0])
            )
        ) && !(datatypeForChangeReport !== 'boolean' && !previousInitialValue && !previousFinalValue && !publicationFormState[elementName])
    ) {
        console.log("resourceUpdate for Citation.citedArtifact.publicationForm[" + index + "]." + elementName);
        let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
        if (!newResourceDetail.revisedResourceJson.citedArtifact) {
            newResourceDetail.revisedResourceJson.citedArtifact = {};
        }
        if (!newResourceDetail.revisedResourceJson.citedArtifact.publicationForm) {
            newResourceDetail.revisedResourceJson.citedArtifact.publicationForm = [];
        }
        if (!newResourceDetail.revisedResourceJson.citedArtifact.publicationForm[index]) {
            newResourceDetail.revisedResourceJson.citedArtifact.publicationForm.push({});
        }
        newResourceDetail.revisedResourceJson.citedArtifact.publicationForm[index][elementName] = publicationFormState[elementName];
        dispatch(resourceUpdated(newResourceDetail));
    }
}

const updateCitedArtifactContributorshipEntryElement = (contributorshipEntryState, index, elementName,
    datatypeForChangeReport, parentResourceDetail, dispatch) => {
    const previousInitialValue = parentResourceDetail.resourceJson.citedArtifact?.contributorship?.entry?.[index]?.[elementName];
    const previousFinalValue = parentResourceDetail.revisedResourceJson.citedArtifact?.contributorship?.entry?.[index]?.[elementName];
    if (contributorshipEntryState[elementName] !== undefined &&
        !jsonEquals(previousFinalValue, contributorshipEntryState[elementName]) &&
        !(!previousInitialValue &&
            Array.isArray(contributorshipEntryState[elementName]) &&
            (contributorshipEntryState[elementName].length === 0 ||
                (contributorshipEntryState[elementName].length === 1 && !contributorshipEntryState[elementName][0])
            )
        ) && !(datatypeForChangeReport !== 'boolean' && !previousInitialValue && !previousFinalValue && !contributorshipEntryState[elementName])
    ) {
        console.log("resourceUpdate for Citation.citedArtifact.contributorship.entry[" + index + "]." + elementName);
        let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
        if (!newResourceDetail.revisedResourceJson.citedArtifact) {
            newResourceDetail.revisedResourceJson.citedArtifact = {};
        }
        if (!newResourceDetail.revisedResourceJson.citedArtifact.contributorship) {
            newResourceDetail.revisedResourceJson.citedArtifact.contributorship = {};
        }
        if (!newResourceDetail.revisedResourceJson.citedArtifact.contributorship.entry) {
            newResourceDetail.revisedResourceJson.citedArtifact.contributorship.entry = [];
        }
        if (!newResourceDetail.revisedResourceJson.citedArtifact.contributorship.entry[index]) {
            newResourceDetail.revisedResourceJson.citedArtifact.contributorship.entry.push({});
        }
        newResourceDetail.revisedResourceJson.citedArtifact.contributorship.entry[index][elementName] = contributorshipEntryState[elementName];
        dispatch(resourceUpdated(newResourceDetail));
    }
}

const updateCitedArtifactContributorshipSummaryElement = (contributorshipSummaryState, index, elementName,
    parentResourceDetail, dispatch) => {
    const previousInitialValue = parentResourceDetail.resourceJson.citedArtifact?.contributorship?.summary?.[index]?.[elementName];
    const previousFinalValue = parentResourceDetail.revisedResourceJson.citedArtifact?.contributorship?.summary?.[index]?.[elementName];

    if (contributorshipSummaryState[elementName] !== undefined &&
        !jsonEquals(previousFinalValue, contributorshipSummaryState[elementName]) &&
        !(!previousInitialValue &&
            Array.isArray(contributorshipSummaryState[elementName]) &&
            (contributorshipSummaryState[elementName].length === 0 ||
                (contributorshipSummaryState[elementName].length === 1 && !contributorshipSummaryState[elementName][0])
            )
        ) && !(!previousInitialValue && !previousFinalValue && !contributorshipSummaryState[elementName])
    ) {
        console.log("resourceUpdate for Citation.citedArtifact.contributorship.summary[" + index + "]." + elementName);
        let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
        if (!newResourceDetail.revisedResourceJson.citedArtifact) {
            newResourceDetail.revisedResourceJson.citedArtifact = {};
        }
        if (!newResourceDetail.revisedResourceJson.citedArtifact.contributorship) {
            newResourceDetail.revisedResourceJson.citedArtifact.contributorship = {};
        }
        if (!newResourceDetail.revisedResourceJson.citedArtifact.contributorship.summary) {
            newResourceDetail.revisedResourceJson.citedArtifact.contributorship.summary = [];
        }
        if (!newResourceDetail.revisedResourceJson.citedArtifact.contributorship.summary[index]) {
            newResourceDetail.revisedResourceJson.citedArtifact.contributorship.summary.push({});
        }
        newResourceDetail.revisedResourceJson.citedArtifact.contributorship.summary[index][elementName] = contributorshipSummaryState[elementName];
        dispatch(resourceUpdated(newResourceDetail));
    }
}

const updateArtifactAssessmentContentElement = (contentState, index, elementName, datatypeForChangeReport, parentResourceDetail,
    dispatch) => {
    const previousInitialValue = parentResourceDetail.resourceJson.content?.[index]?.[elementName];
    const previousFinalValue = parentResourceDetail.revisedResourceJson.content?.[index]?.[elementName];
    if (contentState[elementName] !== undefined &&
        !jsonEquals(previousFinalValue, contentState[elementName]) &&
        !(!previousInitialValue &&
            Array.isArray(contentState[elementName]) &&
            (contentState[elementName].length === 0 ||
                (contentState[elementName].length === 1 && !contentState[elementName][0])
            )
        ) && !(datatypeForChangeReport !== 'boolean' && !previousInitialValue && !previousFinalValue && !contentState[elementName])
    ) {
        console.log("resourceUpdate for ArtifactAssessment.content[" + index + "]." + elementName);

        let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
        if (!newResourceDetail.revisedResourceJson.content) {
            newResourceDetail.revisedResourceJson.content = [];
        }
        if (!newResourceDetail.revisedResourceJson.content[index]) {
            newResourceDetail.revisedResourceJson.content.push({});
        }
        newResourceDetail.revisedResourceJson.content[index][elementName] = contentState[elementName];
        dispatch(resourceUpdated(newResourceDetail));
    }
}

const updateArtifactAssessmentComponentElement = (contentState, index, componentPath, elementName, datatypeForChangeReport, parentResourceDetail,
    dispatch) => {
    let previousInitialValue = null;
    let previousFinalValue = null;
    const pathLength = componentPath.length;
    if (pathLength === 1) {
        previousInitialValue = parentResourceDetail.resourceJson.content?.[index]?.component?.[componentPath[0]]?.[elementName];
        previousFinalValue = parentResourceDetail.revisedResourceJson.content?.[index]?.component?.[componentPath[0]]?.[elementName];
    } else if (pathLength === 2) {
        previousInitialValue = parentResourceDetail.resourceJson.content?.[index]?.component?.[componentPath[0]]?.component?.[componentPath[1]]?.[elementName];
        previousFinalValue = parentResourceDetail.revisedResourceJson.content?.[index]?.component?.[componentPath[0]]?.component?.[componentPath[1]]?.[elementName];
    } else if (pathLength === 3) {
        previousInitialValue = parentResourceDetail.resourceJson.content?.[index]?.component?.[componentPath[0]]?.component?.[componentPath[1]]?.component?.[componentPath[2]]?.[elementName];
        previousFinalValue = parentResourceDetail.revisedResourceJson.content?.[index]?.component?.[componentPath[0]]?.component?.[componentPath[1]]?.component?.[componentPath[2]]?.[elementName];
    } else if (pathLength === 4) {
        previousInitialValue = parentResourceDetail.resourceJson.content?.[index]?.component?.[componentPath[0]]?.component?.[componentPath[1]]?.component?.[componentPath[2]]?.component?.[componentPath[3]]?.[elementName];
        previousFinalValue = parentResourceDetail.revisedResourceJson.content?.[index]?.component?.[componentPath[0]]?.component?.[componentPath[1]]?.component?.[componentPath[2]]?.component?.[componentPath[3]]?.[elementName];
    } else if (pathLength === 5) {
        previousInitialValue = parentResourceDetail.resourceJson.content?.[index]?.component?.[componentPath[0]]?.component?.[componentPath[1]]?.component?.[componentPath[2]]?.component?.[componentPath[3]]?.component?.[componentPath[4]]?.[elementName];
        previousFinalValue = parentResourceDetail.revisedResourceJson.content?.[index]?.component?.[componentPath[0]]?.component?.[componentPath[1]]?.component?.[componentPath[2]]?.component?.[componentPath[3]]?.component?.[componentPath[4]]?.[elementName];
    }
    if (contentState[elementName] !== undefined &&
        !jsonEquals(previousFinalValue, contentState[elementName]) &&
        !(!previousInitialValue &&
            Array.isArray(contentState[elementName]) &&
            (contentState[elementName].length === 0 ||
                (contentState[elementName].length === 1 && !contentState[elementName][0])
            )
        ) && !(datatypeForChangeReport !== 'boolean' && !previousInitialValue && !previousFinalValue && !contentState[elementName])
    ) {
        console.log("resourceUpdate for ArtifactAssessment.content[" + index + "].component[" + componentPath.join(",") + "]." + elementName);
        let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
        if (!newResourceDetail.revisedResourceJson.content) {
            newResourceDetail.revisedResourceJson.content = [];
        }
        if (!newResourceDetail.revisedResourceJson.content[index]) {
            newResourceDetail.revisedResourceJson.content.push({});
        }
        if (pathLength === 1) {
            if (!newResourceDetail.revisedResourceJson.content[index].component) {
                newResourceDetail.revisedResourceJson.content[index].component = [];
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]]) {
                newResourceDetail.revisedResourceJson.content[index].component.push({});
            }
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]][elementName] = contentState[elementName];
        } else if (pathLength === 2) {
            if (!newResourceDetail.revisedResourceJson.content[index].component) {
                newResourceDetail.revisedResourceJson.content[index].component = [];
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]]) {
                newResourceDetail.revisedResourceJson.content[index].component.push({});
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component) {
                newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component = [];
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]]) {
                newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component.push({});
            }
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]][elementName] = contentState[elementName];
        } else if (pathLength === 3) {
            if (!newResourceDetail.revisedResourceJson.content[index].component) {
                newResourceDetail.revisedResourceJson.content[index].component = [];
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]]) {
                newResourceDetail.revisedResourceJson.content[index].component.push({});
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component) {
                newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component = [];
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]]) {
                newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component.push({});
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component) {
                newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component = [];
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component?.[componentPath[0]].component[componentPath[1]].component[componentPath[2]]) {
                newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component.push({});
            }
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component[componentPath[2]][elementName] = contentState[elementName];
        } else if (pathLength === 4) {
            if (!newResourceDetail.revisedResourceJson.content[index].component) {
                newResourceDetail.revisedResourceJson.content[index].component = [];
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]]) {
                newResourceDetail.revisedResourceJson.content[index].component.push({});
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component) {
                newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component = [];
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]]) {
                newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component.push({});
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component) {
                newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component = [];
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component?.[componentPath[0]].component[componentPath[1]].component[componentPath[2]]) {
                newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component.push({});
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component.component[componentPath[2]].component) {
                newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component.component[componentPath[2]].component = [];
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component[componentPath[2]].component[componentPath[3]]) {
                newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component[componentPath[2]].component.push({});
            }
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component[componentPath[2]].component[componentPath[3]][elementName] = contentState[elementName];
        } else if (pathLength === 5) {
            if (!newResourceDetail.revisedResourceJson.content[index].component) {
                newResourceDetail.revisedResourceJson.content[index].component = [];
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]]) {
                newResourceDetail.revisedResourceJson.content[index].component.push({});
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component) {
                newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component = [];
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]]) {
                newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component.push({});
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component) {
                newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component = [];
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component?.[componentPath[0]].component[componentPath[1]].component[componentPath[2]]) {
                newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component.push({});
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component.component[componentPath[2]].component) {
                newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component.component[componentPath[2]].component = [];
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component[componentPath[2]].component[componentPath[3]]) {
                newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component[componentPath[2]].component.push({});
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component.component[componentPath[2]].component[componentPath[3]].component) {
                newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component.component[componentPath[2]].component[componentPath[3]].component = [];
            }
            if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component[componentPath[2]].component[componentPath[3]].component[componentPath[4]]) {
                newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component[componentPath[2]].component[componentPath[3]].component.push({});
            }
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component[componentPath[2]].component[componentPath[3]].component[componentPath[4]][elementName] = contentState[elementName];
        }
        dispatch(resourceUpdated(newResourceDetail));
    }
}

const getNestedConcept = (resource, conceptPath) => {
    if (!conceptPath.length) {
        alert("UNEXPECTED CodeSystemTermEdit call for concept editing: conceptPath length = 0");
        return undefined;
    }
    return conceptPath.reduce((currentConcept, index) => {
        return currentConcept?.concept?.[index];
    }, resource);
}

const getNestedElementFromConcept = (resource, conceptPath, elementName) => {
    return getNestedConcept(resource, conceptPath)?.[elementName];
}

const updateCodeSystemConceptElement = (codeSystemTermState, conceptPath, elementName,
    datatypeForChangeReport, parentResourceDetail, dispatch, conceptSelected) => {
    const previousInitialValue = getNestedElementFromConcept(parentResourceDetail.resourceJson, conceptPath, elementName) ?? null;
    if (codeSystemTermState[elementName] !== undefined && conceptSelected &&
        (previousInitialValue || !Array.isArray(codeSystemTermState[elementName]) || codeSystemTermState[elementName].length > 1 || codeSystemTermState[elementName][0])
    ) {
        const previousFinalValue = getNestedElementFromConcept(parentResourceDetail.revisedResourceJson, conceptPath, elementName) ?? null;
        if ((datatypeForChangeReport === 'boolean' || previousInitialValue || previousFinalValue || codeSystemTermState[elementName])
            && !jsonEquals(previousFinalValue, codeSystemTermState[elementName])
        ) {
            const conceptPathString = conceptPath.map(index => `concept[${index}]`).join('.');
            console.log("resourceUpdate for CodeSystem." + conceptPathString + "." + elementName);
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            getNestedConcept(newResourceDetail.revisedResourceJson, conceptPath)[elementName] = codeSystemTermState[elementName];
            dispatch(resourceUpdated(newResourceDetail));
            let newConceptSelected = JSON.parse(JSON.stringify(conceptSelected));
            newConceptSelected[elementName] = codeSystemTermState[elementName];
            dispatch(changeConceptSelected(newConceptSelected));
        }
    }
}

export default updateElement;
export {
    updateNarrativeElement,
    updateCitedArtifactElement, updateCitedArtifactPublicationFormElement,
    updateCitedArtifactContributorshipEntryElement, updateCitedArtifactContributorshipSummaryElement,
    updateArtifactAssessmentContentElement, updateArtifactAssessmentComponentElement,
    updateCodeSystemConceptElement
};